import DeclarantLanguageSelector from './LanguageSelector'

export default function AppFooter() {
  return (
    <footer className="sm:left-64 bottom-0 left-0 bg-white p-4 mt-auto">
      <div className="flex justify-between items-center">
        <div className="text-xs text-text-secondary font-medium">
          <p>© {new Date().getFullYear()} Artem Technologie AG</p>
        </div>
        <DeclarantLanguageSelector showLabel />
      </div>
    </footer>
  )
}
